import getField from '@form/formGenerator'

export const nuisanceSaveUrl = `${import.meta.env.VITE_API_URL}/api/nuisances`

export const nuisanceFormObject = {
  id: null,
  label: null,
  isActive: false,
  mission: null
}

export const nuisanceFormFields = (nuisanceFormObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'label',
      label: t('labels.label'),
      value: nuisanceFormObject.label,
      key: 'nuisanceFormObject-label',
      cssClass: 'column is-12'
    },
    {
      type: 'switcher',
      name: 'isActive',
      label: t('labels.is_active'),
      value: nuisanceFormObject.isActive,
      cssClass: 'column is-12',
      key: 'nuisanceFormObject-isActive',
      id: 'nuisanceFormObject-isActive',
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'nuisanceFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(nuisanceFormObject.id),
      key: 'nuisanceFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}